import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import withModal from '../../../../../../../components/global/modal/withModal';
import PhotoManagerSubscriptionCheckout from './PhotoManagerSubscriptionCheckout';
import Button from '../../../../../../../components/global/Button';

const propTypes = {
  className: PropTypes.string,
  actionProps: PropTypes.shape({
    title: PropTypes.node,
    content: PropTypes.node,
    hasActiveSubscription: PropTypes.bool,
    onCheckoutSuccess: PropTypes.func,
  }),
  onRequestClose: PropTypes.func.isRequired,
};

const PhotoManagerSubscriptionCheckoutModal = ({
  className,
  actionProps = {},
  onRequestClose,
}) => {
  const classes = classNames({
    'photo-manager-subscription-checkout-modal': true,
    [className]: !!className,
  });

  const {
    title,
    content,
    photoManagerSubscription,
    onCheckoutSuccess,
  } = actionProps;

  const hasActiveSubscription = !!photoManagerSubscription;
  const isTrial = photoManagerSubscription?.trial_days > 0;

  return (
    <div className={classes}>
      {title && (
        <p className="photo-manager-subscription-checkout-modal-title">
          {title}
        </p>
      )}
      <div className="photo-manager-subscription-checkout-modal-content">
        {content}
      </div>

      {hasActiveSubscription && !isTrial && (
        <Fragment>
          <div className="table-responsive horizontal-scroller">
            <table className="table table-striped mb-3">
              <thead className="text-bold text-sm">
                <tr>
                  <td>Storage</td>
                  <td>Monthly</td>
                  <td>&nbsp;</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Up to 1 TB</td>
                  <td>Included</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td>Every additional TB</td>
                  <td>$25.00</td>
                  <td>&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="mb-2">
            Please click <span className="text-primary">Accept</span> to agree
            to Waldo&apos;s additional storage pricing. You will be billed on
            your next cycle.
          </p>
          <div className="d-none d-md-flex mb-4">
            <div className="w-50 pr-1">
              <Button
                btnBlock
                btnOutline
                btnSize="lg"
                onClick={() => onRequestClose()}
              >
                Go Back
              </Button>
            </div>
            <div className="w-50 pl-1">
              <Button
                btnBlock
                btnSize="lg"
                onClick={() => {
                  onRequestClose();
                  onCheckoutSuccess?.();
                }}
              >
                Accept
              </Button>
            </div>
          </div>
          <div className="d-block d-md-none">
            <Button
              btnBlock
              btnSize="lg"
              onClick={() => {
                onRequestClose();
                onCheckoutSuccess?.();
              }}
            >
              Accept
            </Button>
            <Button
              btnBlock
              btnOutline
              btnSize="lg"
              className="mt-2"
              onClick={() => onRequestClose()}
            >
              Go Back
            </Button>
          </div>
        </Fragment>
      )}

      {(isTrial || !hasActiveSubscription) && (
        <PhotoManagerSubscriptionCheckout
          displayActiveSubscription={isTrial}
          onCheckoutSuccess={async () => {
            onRequestClose();
            await onCheckoutSuccess?.();
          }}
        />
      )}
    </div>
  );
};

PhotoManagerSubscriptionCheckoutModal.propTypes = propTypes;

export const PHOTO_MANAGER_SUBSCRIPTION_CHECKOUT_MODAL =
  'modal/PHOTO_MANAGER_SUBSCRIPTION_CHECKOUT';

export default withModal(PhotoManagerSubscriptionCheckoutModal, {
  name: PHOTO_MANAGER_SUBSCRIPTION_CHECKOUT_MODAL,
  size: 'md',
  type: 'full',
  hideHeader: false,
});
